import Strip from './Strip';

export default Strip;
